import { createGenericSlice, GenericActions, GenericState } from "../GenericSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { OrderUi } from "../../app/Subscriptions/types/OrderListUi";

type State = {
    data: OrderUi[];
};

const initialState: State = {
    data: []
};

export const OrderStatsSlice = createGenericSlice({
    name: "orderStats",
    initialState: initialState as GenericState<OrderUi[]>,
    reducers: {
        success: {
            reducer: (state: { data: OrderUi[]; status: string; }, action: PayloadAction<OrderUi[]>) => {
                state.data = action.payload;
                state.status = 'finished';
            },
            prepare: ({ data: cOrder, role }) => {
                cOrder = cOrder || [];
                


                const Dateoptions = { day: 'numeric', month: 'short', year: 'numeric' };
                const ordersArray: OrderUi[] = cOrder.map((mOrder: any) => {


                    return {
                        id: mOrder.id,
                        chargeable: mOrder.chargeable,
                        subpic: mOrder.subscriptionPic,
                        paymentstatus: mOrder.payment_status,
                        link: mOrder.payment_link,
                        settled: mOrder.settlement_status,
                        cycleName: mOrder.cycleName,
                        subscriptionName: mOrder.subscriptionName,
                        subscriptionId: mOrder.subscriptionId,
                        livesubscriptionId: mOrder.livesubscriptionId,
                        BillingEndTime: mOrder.BillingEndTime?.toDate().toLocaleDateString('en-US', Dateoptions),
                        BillingStartTime: mOrder.BillingStartTime?.toDate().toLocaleDateString('en-US', Dateoptions),
                        lastReminderTime: mOrder.lastReminderTime?.toDate().toLocaleDateString('en-US', Dateoptions),
                        businessName: mOrder.businessName,
                        orderType: mOrder.orderType,
                        Invoice_pdf_link: mOrder.pdf_link,
                        subscriptionPic: mOrder.subscriptionPic,
                        receipt_link: mOrder.receipt_link,
                        studentName: mOrder.studentName,
                        consumerName: mOrder.consumerName,
                        providerName: mOrder.providerName,
                        consumerPhone: mOrder.consumerPhone,
                        settlementStatus: mOrder.settlement_status,
                        reminderCount: mOrder.reminderCount || 0,
                        billingCycle: mOrder.billingCycle || null,
                        subscriptionType: mOrder.subscriptionType || null,
                        count: mOrder.count || 0,
                        validity: mOrder.validity || 0,
                        platformFees: mOrder.platformFees || 0,
                        secondaryMobile: mOrder.secondaryMobile || "",
                        assignedPlanIndex: mOrder.assignedPlanIndex || 0,
                        assignedPlans: mOrder.assignedPlans || [],
                        items: mOrder.items || [],
                        bQuickCollect: mOrder.bQuickCollect || false,
                        quickCollectString: mOrder.quickCollectString || "",
                        invoiceString: mOrder.invoiceString || "",
                        email: mOrder.email || "",
                        secondaryEmail: mOrder.secondaryEmail || "",
                        orderNote: mOrder.orderNote || ""
                    };
                });

                const assignedSubscriptions = role?.assignedSubscriptions;
                const activeRole = role?.role;
               
                if (assignedSubscriptions && (activeRole === "Manager" || activeRole === "Observer")) {
                    
                    const filteredOrders = ordersArray.filter(order => assignedSubscriptions.includes(order.subscriptionId));
                    return { payload: filteredOrders }
                }

                return { payload: ordersArray };
            }
        }
    }
});

export const actions = OrderStatsSlice.actions as GenericActions<OrderUi[]>;

export default OrderStatsSlice.reducer;
